import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * Custom merge config: register our brand typography classes
 * (`text-display-*`, `text-subline`, `text-body`, `text-cta`,
 * `text-annotation`, `text-eyebrow`) as their OWN class group so
 * twMerge does not strip them when combined with text color
 * utilities like `text-clarus-dark` / `text-white`.
 */
const twMerge = extendTailwindMerge<"brand-typography">({
  extend: {
    classGroups: {
      "brand-typography": [
        {
          text: [
            "display-xl",
            "display-lg",
            "display-md",
            "subline",
            "body",
            "cta",
            "cta-lg",
            "annotation",
            "eyebrow",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export const siteConfig = {
  name: "ClarusPlus",
  url: process.env.NEXT_PUBLIC_SITE_URL ?? "https://clarusplus.com",
  companyLegal: "LureLink UG (haftungsbeschränkt)",
  city: "Zossen",
  country: "Germany",
} as const;
